function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "icon-device--laptop_svg__a",
  x1: 9.41,
  y1: 22.74,
  x2: 23.27,
  y2: 8.88,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#646a70"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#bcc4c9"
})), React.createElement("linearGradient", {
  id: "icon-device--laptop_svg__b",
  x1: 5.06,
  y1: 15.03,
  x2: 23.94,
  y2: 15.03,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#bcc4c9"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#e2e6e9"
})), React.createElement("linearGradient", {
  id: "icon-device--laptop_svg__c",
  x1: 19.22,
  y1: 21.21,
  x2: 30.37,
  y2: 10.05,
  xlinkHref: "#icon-device--laptop_svg__b"
}), React.createElement("g", {
  id: "icon-device--laptop_svg__d"
}, React.createElement("path", {
  d: "M4.56 7.06h22.88a.5.5 0 01.5.5v17.38H4.06V7.56a.5.5 0 01.5-.5z",
  fill: "url(#icon-device--laptop_svg__a)"
}), React.createElement("path", {
  d: "M18.94 23.49a.49.49 0 01-.49.49h-4.91a.49.49 0 01-.49-.49.49.49 0 00-.49-.49h-11a.56.56 0 00-.56.56.56.56 0 00.39.53l2.61.84h24l2.57-.83a.56.56 0 00.39-.53.56.56 0 00-.56-.56h-11a.49.49 0 00-.46.48z",
  fill: "#44484c"
}), React.createElement("path", {
  fill: "url(#icon-device--laptop_svg__b)",
  d: "M23.94 8.06H5.06V22H10L23.94 8.06z"
}), React.createElement("path", {
  d: "M27 8.06h-3.06L10 22h16.75a.25.25 0 00.25-.25z",
  fill: "url(#icon-device--laptop_svg__c)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#icon-device--laptop_svg__d"
});

var SvgIconDeviceLaptop = function SvgIconDeviceLaptop(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-device--laptop.df1aaed2.svg";
export { SvgIconDeviceLaptop as ReactComponent };